import { AgentsAvailabilityPage } from 'app/components/agents-hub/AgentsAvailabilityPage'

export const handle = {
  title: `Agents · Availability`,
  breadcrumb: `Availability`,
}

export default function AgentsAvailabilityRoute() {
  return <AgentsAvailabilityPage />
}
